import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { HStack } from "@design-system/HStack/HStack";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    SCHEDULE_APPLICATIONS_EMPTY_VALUE,
    ScheduleApplicationRow,
} from "../scheduleApplicationRowHelpers";
import { getScheduleApplicationRowStatus } from "../scheduleApplicationStatusDisplay";
import { getScheduleBillingStatusDisplay } from "../scheduleBillingStatusDisplay";

export const ScheduleApplicationStatusCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ScheduleApplicationRow, string>) => {
        const rowData = row.original;
        const status = getScheduleApplicationRowStatus(rowData);
        const billingStatus =
            rowData.rowType === "application"
                ? getScheduleBillingStatusDisplay({
                      sourceType: rowData.sourceType,
                      amount: rowData.amount,
                      billing: rowData.billing,
                  })
                : null;
        if (!status) {
            return (
                <ViewTableCell>
                    {SCHEDULE_APPLICATIONS_EMPTY_VALUE}
                </ViewTableCell>
            );
        }
        return (
            <ViewTableCell>
                <HStack as="span" gap={4} align="center">
                    <Tooltip content={status.tooltip}>
                        <span>
                            {status.label}
                            {billingStatus && ","}
                        </span>
                    </Tooltip>
                    {billingStatus && (
                        <Tooltip content={billingStatus.tooltip}>
                            <span>{billingStatus.label}</span>
                        </Tooltip>
                    )}
                </HStack>
            </ViewTableCell>
        );
    },
);
ScheduleApplicationStatusCell.displayName = "ScheduleApplicationStatusCell";
